import {GET_FRONT_COVER_PAGE_DETAILS_SUCCESS, GET_FRONT_COVER_THUMBNAIL_URL} from '../_actions/bookdetails.actions';

export const INITIAL_STATE = {
    bookTitle: '',
    coverPageUrl: '',
    coverImage: 'zero',
    field2: '',
    field3: '',
    field4: '',
    id: '',
    imageId: '',
    templateNumber: 'default_template',
    thumbnailUrl: '',
    firstLoad: true,
    trimCode: 'TS_8_5x11',
    frontCoverurl :'',
    frontCoverPageDetail: [
        {
            color: '0/0/0/0',
            colorRGB: '0/0/0',
            fieldName: 'Field1',
            fontLeading: '0',
            fontSize: '0',
            fontType: 'default.ttf',
            textBoxHeight: '0',
            textBoxWidth: '0',
            textSize: '0',
            textAlignment: 'left',
            xPosition: '0',
            yPosition: '0'
        },
        {
            color: '0/0/0/0',
            colorRGB: '0/0/0',
            fieldName: 'Field2',
            fontLeading: '0',
            fontSize: '0',
            fontType: 'default.ttf',
            textBoxHeight: '0',
            textBoxWidth: '0',
            textSize: '0',
            textAlignment: 'left',
            xPosition: '0',
            yPosition: '0'
        },
        {
            color: '0/0/0/0',
            colorRGB: '0/0/0',
            fieldName: 'Field3',
            fontLeading: '0',
            fontSize: '0',
            fontType: 'default.ttf',
            textBoxHeight: '0',
            textBoxWidth: '0',
            textSize: '0',
            textAlignment: 'left',
            xPosition: '0',
            yPosition: '0'
        },
        {
            color: '0/0/0/0',
            colorRGB: '0/0/0',
            fieldName: 'Field4',
            fontLeading: '0',
            fontSize: '0',
            fontType: 'default.ttf',
            textBoxHeight: '0',
            textBoxWidth: '0',
            textSize: '0',
            textAlignment: 'left',
            xPosition: '0',
            yPosition: '0'
        }

    ]
};

export function coverReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_FRONT_COVER_PAGE_DETAILS_SUCCESS: {
            return action.payload;

        }
        case GET_FRONT_COVER_THUMBNAIL_URL: {
            return {...state, coverPageUrl: action.payload};
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/cover.reducer.js